import { render } from "./CancelBaselineIcon.vue?vue&type=template&id=574a684c"
import script from "./CancelBaselineIcon.vue?vue&type=script&lang=js"
export * from "./CancelBaselineIcon.vue?vue&type=script&lang=js"
script.render = render

export default script